<template>
	<span class="proview">
						<b-modal id="previewproduct" title="Product Preview" size="lgme" class="previewproductModel" ok-only >
								
									<b-container fluid>
									
										 <div 
										  id="iframe-wrapper"
										  :style="iframe.wrapperStyle" 
										>
										  <iframe 
											v-if="loaded"
											:src="productviewlink"
											:style="iframe.style"
											:height="iframe.style.height"
											:width="iframe.style.width"
											type="application/pdf"
											frameborder="0"
											class="previewProduct"										
											 ref="pviframe"
											 id="pviframe"
											 contenteditable="true"
										  ></iframe>
										</div>						
														
									</b-container>
								
								<template v-slot:modal-footer="{ ok, close }">
									<b-button size="sm" variant="danger" @click="close()" style="display:none;">Cancel</b-button>
									<!-- <b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button> -->
									
									
										<!-- {{ tabIndex }}
										{{selectedItem.product_type}} -->
										
										
										
										
										
								</template>
							</b-modal>

			
			


		</span>		
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
export default {
  name: 'Previewproduct',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  },
  props: { 
	productviewlink:String,
	
  },
  mounted(){
    this.inLodcard();
	
	//"iframe contenteditable=“true” id=“preview_iframe” ref=“preview_iframe” class=“someClass” src=“somepaage.html’” >

//this.$refs['pviframe'].contentWindow.document.getElementById(“title_iframe”).innerHTML = this.title
//this.$refs['pviframe'].contentWindow.document.getElementsByClassName('header').innerHTML = 'dddd sd asd asdaxasfsf werfewferghsdf dfgggergerrrrr'
/* var iframe = document.getElementById("pviframe");
var elmnt = iframe.contentWindow.document.getElementsByClassName("header")[0];
elmnt.style.display = "none";*/


/*
var iframevar = document.getElementById('pviframe');
var elmnt = iframevar.contentWindow.document.getElementsByClassName("header");
elmnt.innerHTML = 'vijay'; */

  },
  computed: {
    
  },
  data() {
    return{
		loaded: false,
		iframe: {
		src: window.location.href,
		style: null,
		wrapperStyle: null,
		}
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
		var self =this;	
		//self.iframe.src='https://www.alluraa.com/product/c0c894ff-1772-4c51-997e-93371a75e5a9'; 
		self.iframe.style = {
		//position: 'absolute',
		width: window.innerWidth,
		height: window.innerHeight,
		// top: -editor.offsetTop + "px",
		// left: -editor.offsetLeft + "px",
		}    
		self.iframe.wrapperStyle = {
		overflow: 'hidden',
		// height: editor.clientHeight + "px",
		//width: editor.clientWidth + "px",
		} 
		self.loaded = true;
		},
		changeMessage(arg){		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        }

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    lang="scss">

.modal-lgme{
max-width: 100% !important;
max-height: 100% !important;
}
.previewProduct{
	/* border:1px solod red;
	background:red; */
	.header{ display:none;}
}
.previewProduct .header{ display:none;}
</style>
